import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../castle-kit';
import * as g from '../../castle-kit-grounds';

/**
 * THE DUNGEON (Темница) — the castle's DARK, isolated under-floor, composed for DREAD THROUGH EMPTINESS.
 * The HERO is the bank of barred CELLS hugging the long walls; everything else is restrained. One cell
 * holds a forgotten prisoner's straw pallet, another a long-dead prisoner's bones; a single set of
 * manacles is bolted to the cold stone, and two lone, guttering wall torches are the ONLY light, so the
 * cells loom out of shadow. The wide central floor is deliberately BARE — the cold, empty stone is the
 * point. Cartoon-spooky, never gory.
 *
 * Geometry: zone (360,2040) 440×600 → centre (580,2340). Doors kept clear: N@x580, W@y2340, E@y2170,
 * E@y2470. The central cross + each door mouth stay walkable; all set-dressing hugs the walls / sits
 * inside the cells. 8 pieces — sparse on purpose.
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;

  // ── The barred CELLS — the HERO bank of iron, ranged along the long walls (off the door mouths). ──
  place(ctx, g.jailBars(art, 120, 140), 440, 2160); // NW cell front
  place(ctx, g.jailBars(art, 120, 140), 440, 2520); // SW cell front
  place(ctx, g.jailBars(art, 120, 140), 720, 2160); // NE cell front

  // ── Inside the cells: a prisoner's straw pallet, and a forgotten prisoner's bones in the locked cell. ──
  place(ctx, g.strawBed(art), 450, 2240); // pallet behind the NW bars
  place(ctx, g.bonePile(art), 450, 2560); // a forgotten prisoner behind the SW bars

  // ── A single set of MANACLES bolted to the cold north stone (one accent, not a clutter of chains). ──
  place(ctx, g.manacles(art), 580, 2120);

  // ── The dungeon SEAT — a lone stool on the bare central floor (load-bearing seat anchor). ──
  place(ctx, kit.woodStool(art), 580, 2340); // dungeon-bench seat anchor @ (580,2340)

  // ── The only light: two lone, guttering wall torches — cold + sparse, the cells loom out of shadow. ──
  place(ctx, kit.wallTorch(art), 580, 2160); // by the north wall + the manacles
  place(ctx, kit.wallTorch(art), 580, 2540); // by the south cell + the bones
};

export default decorate;
